import { z } from 'zod'

export const expectedPaymentTypeSchema = z.enum(['DIVIDEND', 'COUPON'])
export type ExpectedPaymentType = z.infer<typeof expectedPaymentTypeSchema>

export const expectedPaymentResponseSchema = z.object({
  id: z.string().guid(),
  instrumentUid: z.string(),
  figi: z.string().nullable(),
  ticker: z.string().nullable(),
  instrumentName: z.string().nullable(),
  // lowercase T-Bank instrument kind ('share' | 'bond' | 'etf') from the local instrument cache;
  // optional, since the cache is filled lazily and older cached responses omit it
  instrumentType: z.string().nullable().optional(),
  type: expectedPaymentTypeSchema,
  recordDate: z.coerce.date().nullable(),
  lastBuyDate: z.coerce.date().nullable(),
  paymentDate: z.coerce.date(),
  amountPerUnit: z.number(),
  currency: z.string().nullable(),
  quantityAtSync: z.number(),
  expectedAmount: z.number(),
  accruedInterest: z.number().nullable(),
  syncedAt: z.coerce.date(),
})

export type ExpectedPaymentResponseDto = z.infer<typeof expectedPaymentResponseSchema>
